import type { LoopConfiguration } from '@/types/loop-configuration';
import type { Property } from '@/types';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { store } from '@/store';
// eslint-disable-next-line import/no-cycle
import { addElementTypeByLang } from '@/composables/template-editor/TemplateEditor';

/**
 * Set loop configuration to s-collection attribute
 */
const setLoopConfiguration = (selector: string, property: Property): void => {
  const template = getTemplateIframeDocument();
  if (!template) {
    return;
  }

  const element: HTMLElement | null = template.querySelector(selector);

  if (!element) {
    return;
  }

  const value = property.value as LoopConfiguration | null;

  if (!value || !value.enabled) {
    // Remove s-collection and s-item attributes and class if loop is disabled or null
    element.removeAttribute('s-collection');
    element.removeAttribute('s-item');
    element.removeAttribute('s-order');
    element.removeAttribute('s-nb');
    element.classList.remove('spm_loop');

    // Update state badges
    addElementTypeByLang(element);

    // Refresh configuration panel to update UI
    store.commit('liveEditor/refreshConfigurationPanelKey');
    return;
  }

  // Set s-collection and s-item attributes
  element.setAttribute('s-collection', value.collection);
  element.setAttribute('s-item', value.iterator);
  element.classList.add('spm_loop');

  // Set s-order attribute if present
  if (value.order) {
    const orderJson = JSON.stringify(value.order);
    element.setAttribute('s-order', orderJson);
  } else {
    element.removeAttribute('s-order');
  }

  // Set s-nb attribute if present
  if (value.limit) {
    element.setAttribute('s-nb', value.limit.toString());
  } else {
    element.removeAttribute('s-nb');
  }

  // Update state badges
  addElementTypeByLang(element);

  // Refresh configuration panel to update UI
  store.commit('liveEditor/refreshConfigurationPanelKey');
};

export default setLoopConfiguration;
